module.exports = __webpack_public_path__ + "static/media/0@3x.3252a58b.png";